import React, { useState } from "react";
import media from "../../../../media";
import ModalWrapper from "../../../../components/atoms/formFields/wrapperModal/modalWrapper";
import { Col, DatePicker, message, Row } from "antd";
import moment from "moment/moment";
import { ContentInputField } from "../../../../components/atoms/formFields/inputField/contentInputField";
import {
  detailsSaleListThunk,
  removeSaleThunk,
  updateSaleThunk,
} from "../../../../store/thunks/InventoryThunk";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";

const Sale = ({ stockVariantData, data, storeId, productId }) => {
  const dispatch = useDispatch();
  const [saleId, setSaleId] = useState();
  const [discount, setDiscount] = useState();
  const [updateSale, setUpdateSale] = useState();
  const [isEndSaleChange, setIsEndSaleChange] = useState(false);
  const [isStartSaleChange, setIsStartSaleChange] = useState(false);
  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title collapsed justify-content-between remove-icon bg-gray-300 rounded-bottom-0">
          <span>Sale</span>

          <span
            className="btn btn-primary font-weight-bold letter-spacing px-4 py-2"
            data-toggle="modal"
            data-target="#updatesalemodal"
          >
            Edit
          </span>
        </div>
      </div>
      <div className="card-body overflow-hidden p-3">
        <div className="d-flex justify-content-between pb-4">
          <div className="bg-light-light border border-1 border-light-dark p-3 start-sale w-100">
            <div className="align-items-center d-flex flex-wrap">
              <div className="symbol symbol-80 symbol-light-success mr-5">
                <span className="border border-1 border-light-dark symbol-label">
                  <img
                    src={data?.images ? data.images[0]?.image : media.Default}
                    className="align-self-center radius w-100 border border-light-infoml h-100 object-fit-contain"
                    alt="pro-img"
                  />
                </span>
              </div>
              <div className="d-flex flex-column flex-grow-1 my-2 my-lg-0">
                <p className="font-size-h5 font-weight-bolder m-0">
                  {data?.name?.en}
                </p>
                <p className="font-size-lg font-weight-bold m-0">
                  Brand : {data?.productDetails?.brand?.name?.en}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="sale-table">
          <div className="table-responsive font-weight-bold">
            <table className="table table-bordered m-0 border radius-remove all_domain_table">
              <thead className="text-white bg-gray-700">
                <tr>
                  <th className="above-column">Size/Model No.</th>
                  <th className="above-column">MRP</th>
                  <th className="above-column">Selling Price</th>
                  <th className="above-column">Sale Price</th>
                  <th className="above-column">Sale Discount Percentage</th>
                </tr>
              </thead>

              <tbody className="font-weight-bolder">
                {stockVariantData?.map((variant, i) => {
                  return (
                    <tr key={i.toString()}>
                      <td className="align-middle">{variant?.variantSize}</td>
                      <td className="align-middle font-weight-bold">
                        {variant?.mrp}
                      </td>
                      <td className="align-middle font-weight-bold">
                        {variant?.price}
                      </td>
                      <td className="align-middle font-weight-bold">
                        {variant?.salePrice}
                      </td>
                      <td className="align-middle font-weight-bold">
                        {variant?.saleDiscountPercentage.toFixed(2)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <ModalWrapper
        name="Update Sale"
        tooltipText={"Update discount, pricing, and sale duration for this product"}
        id="updatesalemodal"
        extraClasses="modal-dialog modal-dialog-centered modal-lg"
      >
        <div className="d-flex justify-content-between pb-4">
          <div className="bg-light-light border border-1 border-light-dark mr-5 p-3 start-sale w-100">
            <div className="align-items-center d-flex flex-wrap">
              <div className="symbol symbol-80 symbol-light-success mr-5">
                <span className="border border-1 border-light-dark symbol-label">
                  <img
                    src={data?.images ? data?.images[0].image : media.Default}
                    className="align-self-center radius max-w-30"
                    alt="img"
                  />
                </span>
              </div>
              <div className="d-flex flex-column flex-grow-1 my-2 my-lg-0">
                <p className="font-size-h5 font-weight-bolder m-0">
                  {data?.name?.en}
                </p>
                <p className="font-size-lg font-weight-bold m-0 my-1">
                  Brand:
                  {data?.productDetails?.brand?.name?.en}
                </p>
                <span className="text-muted font-weight-bold font-size-sm">
                  Published on :{" "}
                  {moment
                    .utc(data?.productDetails?.publishedOn)
                    .local()
                    .format("DD/MM/YYYY")}
                </span>
              </div>
            </div>
          </div>
          <div className="bg-light-light border border-1 border-light-dark p-3 start-sale w-100 text-dark">
            <Row className="mt-2">
              <Col xs={24} lg={12}>
                <span className="font-weight-boldest d-block mb-1">
                  Start Date <span className="text-danger">*</span>
                </span>
                <DatePicker
                  className={"rounded-0"}
                  showTime
                  value={
                    updateSale?.variant?.saleStartDate
                      ? isStartSaleChange
                        ? dayjs(updateSale?.variant?.saleStartDate).local()
                        : dayjs(updateSale?.variant?.saleStartDate)
                            .local()
                            .utc()
                      : null
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={(date, dateString) => {
                    setIsStartSaleChange(true);
                    setUpdateSale({
                      ...updateSale,
                      variant: {
                        ...updateSale?.variant,
                        saleStartDate: dateString
                          ? moment(dateString).format("YYYY-MM-DDTHH:mm:ss")
                          : "",
                      },
                    });
                  }}
                />
              </Col>
              <Col xs={24} lg={12}>
                <span className="font-weight-boldest d-block mb-1">
                  End Sale <span className="text-danger">*</span>
                </span>

                <DatePicker
                  className={"rounded-0"}
                  showTime
                  value={
                    updateSale?.variant?.saleEndDate
                      ? isEndSaleChange
                        ? dayjs(updateSale?.variant?.saleEndDate).local()
                        : dayjs(updateSale?.variant?.saleEndDate).local().utc()
                      : null
                  }
                  getPopupContainer={(trigger) => trigger.parentNode}
                  onChange={(date, dateString) => {
                    setIsEndSaleChange(true);
                    setUpdateSale({
                      ...updateSale,
                      variant: {
                        ...updateSale?.variant,
                        saleEndDate: dateString
                          ? moment(dateString).format("YYYY-MM-DDTHH:mm:ss")
                          : "",
                      },
                    });
                  }}
                />
              </Col>
            </Row>
          </div>
        </div>
        <div className="sale-table">
          <div className="table-responsive font-weight-bold">
            <table className="table table-bordered m-0 border radius-remove all_domain_table">
              <thead className="text-white bg-gray-700">
                <tr>
                  <th className="above-column">Size/Model No.</th>
                  <th className="above-column">MRP</th>
                  <th className="above-column">Selling Price</th>
                  <th className="above-column">Discount Price</th>
                  <th className="above-column">Sale Discount</th>
                  <th className="above-column">Update</th>
                </tr>
              </thead>
              <tbody className="font-weight-bolder">
                {stockVariantData?.map((variant, i) => {
                  return (
                    <React.Fragment key={variant?.id || i}>
                      <tr className="greyBackground invenorysaleInner">
                        <td className="">
                          <ContentInputField
                            value={variant?.variantSize}
                            disabled
                          />
                        </td>
                        <td className="">
                          <ContentInputField value={variant?.mrp} disabled />
                        </td>
                        <td className="">
                          <ContentInputField
                            type="text"
                            value={variant?.price}
                            disabled
                          />
                        </td>
                        <td className="">
                          <ContentInputField
                            placeholder="Discounted Price"
                            type="text"
                            disabled={saleId !== variant?.variantKey}
                            value={
                              variant?.variantKey === saleId
                                ? updateSale?.variant?.saleDiscount ?? ""
                                : variant?.discount != null
                                ? variant.discount.toFixed(2)
                                : ""
                            }
                          />
                        </td>
                        <td className="">
                          <ContentInputField
                            type="number"
                            placeholder="Auto calculate %"
                            disabled={saleId !== variant?.variantKey}
                            onChange={(e) => {
                              const num = e.target.value;
                              const percent =
                                (num / 100) * updateSale?.variant?.mrp;
                              setDiscount(num);
                              setUpdateSale({
                                ...updateSale,
                                variant: {
                                  ...updateSale?.variant,
                                  saleDiscount: num < 101 ? percent : "",
                                },
                              });
                            }}
                          />
                          {discount > 100 && (
                            <small className="text-danger">
                              Sale Discount Should Be Between 0-100
                            </small>
                          )}
                        </td>
                        <td
                          className="align-middle font-weight-bold"
                          nowrap="nowrap"
                        >
                          <i
                            className="flaticon-edit icon-md text-dark font-weight-bold mr-5 cursor-pointer"
                            onClick={() => {
                              setSaleId(variant?.variantKey);
                              setUpdateSale({
                                productId: data?.productId,
                                variant: {
                                  ...variant,
                                  saleStartDate: variant?.saleStartDate
                                    ? moment
                                        (variant?.saleStartDate)
                                        .format("YYYY-MM-DDTHH:mm:ss")
                                    : "",
                                  saleEndDate: variant?.saleEndDate
                                    ? moment
                                        (variant?.saleEndDate)
                                        .format("YYYY-MM-DDTHH:mm:ss")
                                    : "",
                                  saleDiscount: variant?.discount,
                                },
                              });
                            }}
                          ></i>
                          <button
                            type="submit"
                            disabled={saleId !== variant?.variantKey}
                            className="all_bottom_buttons px-5 py-2 radius-0"
                            onClick={(e) => {
                              e.preventDefault();

                              const variantInfo = updateSale?.variant;
                              const {
                                saleStartDate,
                                saleEndDate,
                                saleDiscount,
                                mrp,
                                variantKey,
                              } = variantInfo || {};

                              if (!saleStartDate || !saleEndDate) {
                                if (!saleStartDate) {
                                  message.error("Start Date is required");
                                }
                                if (!saleEndDate) {
                                  message.error("End Date is required");
                                }
                                return;
                              }

                              if (
                                variantKey === saleId &&
                                saleDiscount <= mrp &&
                                productId &&
                                storeId
                              ) {
                                dispatch(
                                  updateSaleThunk({
                                    vendorProductVariantSale: {
                                      productID: productId,
                                      discountType: "FIXED_DISCOUNT",
                                      inventoryId: storeId,
                                      variantId: variantKey,
                                      saleStartDate,
                                      saleEndDate,
                                      saleDiscount,
                                    },
                                  })
                                )
                                  .unwrap()
                                  .then(() => {
                                    setSaleId("");
                                    dispatch(
                                      detailsSaleListThunk({
                                        inventoryProductId: {
                                          inventoryId: storeId,
                                          productId: productId,
                                        },
                                      })
                                    );
                                  });
                              }
                            }}
                          >
                            Save
                          </button>

                          <button
                            type="submit"
                            className="all_bottom_buttons bg-danger px-5 py-2 radius-0"
                            onClick={(e) => {
                              e.preventDefault();
                              dispatch(
                                removeSaleThunk({
                                  inventoryProductId: {
                                    inventoryId: storeId,
                                    productId: productId,
                                    sku: variant?.sku,
                                  },
                                })
                              )
                                .unwrap()
                                .then(() => {
                                  message.success("Sale cleared successfully");
                                  dispatch(
                                    detailsSaleListThunk({
                                      inventoryProductId: {
                                        inventoryId: storeId,
                                        productId: productId,
                                      },
                                    })
                                  );
                                });
                            }}
                          >
                            Clear Sale
                          </button>
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default Sale;
